import React from 'react'
import BaseTick from './BaseTick'
import formatNumber from 'support/formatters/formatNumber'

function NumberTick (props) {
  const {
    payload
  } = props

  const value = payload.value

  return (
    <BaseTick
      {...props}
      header={null}
      subtitle={formatNumber(value)}
    />
  )
}

export default React.memo(NumberTick)
